import React, { useEffect, useState } from "react";
import "./CareerOpenings.css";
import axios from "axios";

const CareerOpenings = () => {
  const [openings, setOpenings] = useState([]);

const API_URL = "https://admin.cmgroupofcompanies.com"; 

  /* ===== FETCH CAREERS FROM DB ===== */
useEffect(() => {
  const fetchCareers = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/careers.php`);
      setOpenings(res.data);
    } catch (error) {
      console.error("Error fetching careers:", error);
    }
  };

  fetchCareers();
}, []);

  return (
    <section className="cm-career-section">
      <h2 className="cm-career-heading">Current Openings</h2>

      <div className="cm-career-list">
  {openings.length === 0 ? (
    <p>No current openings</p>
  ) : (
    openings.map((job) => (
      <div className="cm-career-card" key={job.id}>
        <h3 className="cm-career-title">{job.position}</h3>

        <div className="cm-career-meta">
          <span className="cm-career-exp">
            Experience: {job.experience} years
          </span>
          <span className="cm-career-type">
            {job.job_type}
          </span>
        </div>

        <div className="cm-career-location">
          Location: {job.location}
        </div>
      </div>
    ))
  )}
</div>

    </section>
  );
};

export default CareerOpenings;
